import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { trackEvent } from "@/lib/analytics";

/**
 * JulietteDeeplinkConsumer — consomme le deeplink `?juliette=<sessionId>`.
 *
 * Les notifications push (débrief soir / briefing matin) ouvrent l'app sur
 * `/?juliette=<id>`. Le brief lui-même s'affiche sur le dashboard
 * (Systeme1BriefCard) ; ce composant ne fait que tracer l'ouverture puis
 * retirer le param de l'URL. Il ne rend rien.
 *
 * (Extrait de l'ancien JulietteAssistant lors de sa suppression — seule logique
 * encore utile de ce composant.)
 */
export function JulietteDeeplinkConsumer() {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const julietteParam = searchParams.get("juliette");
    if (!julietteParam) return;
    trackEvent("briefing_opened", {
      session_id: julietteParam,
      from: "push_deeplink",
    });
    const next = new URLSearchParams(searchParams);
    next.delete("juliette");
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  return null;
}
